import React, { useContext } from 'react';

import { Card, CardContent, CardHeader } from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';
import { columnDateTime } from 'src/components/Table/types';
import { IClassification } from 'src/interfaces/models';
import DashboardContext from 'src/pages/Private/Dashboard/context';

const LastBeneficiaries: React.FC = () => {
  const {
    chartsInfo: { lastBeneficiaries },
  } = useContext(DashboardContext);

  return (
    <Card style={{ height: '100%' }}>
      <CardHeader
        style={{ color: '#01CB98' }}
        title="IFEPAF"
        subheader="ÚLTIMAS BENEFICIÁRIAS CADASTRADAS (lista com as 10 últimas no período)"
      />

      <CardContent>
        <DataGrid
          autoHeight
          rows={lastBeneficiaries || []}
          disableColumnMenu
          columns={[
            { field: 'id', headerName: 'ID', sortable: false },
            {
              field: 'display_name',
              headerName: 'Nome',
              flex: 1,
              sortable: false,
            },
            {
              field: 'classification',
              headerName: 'Classificação',
              flex: 1,
              sortable: false,
              valueGetter({ row }) {
                return (
                  row.classifications
                    ?.map(
                      (classification: IClassification) => classification.name,
                    )
                    .join(' - ') || ''
                );
              },
            },
            {
              field: 'created_at',
              headerName: 'Criado Em',
              width: 120,
              sortable: false,
              ...columnDateTime,
            },
          ]}
          hideFooter
        />
      </CardContent>
    </Card>
  );
};

export default LastBeneficiaries;
